export async function openPopup(scope, scenes, name, options = {}) {
    const popup = scenes.add(name, options);
    await scenes.show(name);

    scope.defer(() => {
        scenes.hide(name);
        scenes.remove(name);
    });

    return popup;
}
